import { Component } from '@angular/core';

@Component({
  selector: 'app-button-spinner',
  standalone: false,
  templateUrl: './button-spinner.component.html',
  styleUrl: './button-spinner.component.css'
})
export class ButtonSpinnerComponent {

}
